import { render, staticRenderFns } from "./emergencyResource.vue?vue&type=template&id=4742964c&scoped=true&"
import script from "./emergencyResource.vue?vue&type=script&lang=js&"
export * from "./emergencyResource.vue?vue&type=script&lang=js&"
import style0 from "./emergencyResource.vue?vue&type=style&index=0&id=4742964c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742964c",
  null
  
)

export default component.exports